// modules
import { createAction } from 'redux-actions'

export const setPerformanceDashboardCaseManagers = createAction(
  'SET_PERFORMANCE_DASHBOARD_DATA'
)
export const setPerformanceDashboardGeneralInfo = createAction(
  'SET_PERFORMANCE_DASHBOARD_GENERAL_INFO'
)

export const resetPerformanceDashboardData = createAction(
  'RESET_PERFORMANCE_DASHBOARD_DATA'
)
